import React, { type ReactNode } from "react"

import { cn } from "@/modules/helpers/hooks/shared/utils"
interface IconButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  disabled?: boolean
  type?: "submit" | "button"
  mode?: "linear" | "default" | "ghost"
}
const IconButton: React.FC<IconButtonProps> = ({
  children,
  className,
  mode = "linear",
  ...props
}) => {
  return (
    <button
      disabled={props.disabled}
      className={cn(
        "w-8 h-8  active:scale-[98%] transition-all ease-in-out rounded-full flex items-center justify-center",
        {
          [className as string]: !!className,
          "!bg-slate-200 active:bg-slate-200": !!props?.disabled,
          "bg-primary transition-transform text-white":
            mode === "linear" && !props?.disabled
        }
      )}
      type="button"
      {...props}
    >
      {children}
    </button>
  )
}

export { IconButton }
